import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

// import { BlobService } from '../../core/blob-service/blob-service';
import { ApiService } from '@usimweb/core/services';

@Component({
    selector: 'usimweb-img-blob',
    templateUrl: './img-blob.component.html',
    styleUrls: ['./img-blob.component.scss'],
    standalone: false
})
export class ImgBlobComponent implements OnInit {
  @Input() uuid!: string;
  @Input() preview!: string;
  @Input() png!: SafeUrl;
  public blobUrl: any;

  constructor(private apiService: ApiService, private domSanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.getImg(this.uuid);
  }

  private getImg(uuid: string) {
    if (this.preview === 'mapper') {
      this.apiService.getMappingPreview(uuid).subscribe(
        (val: Blob) => {
          this.blobUrl = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val));
          //this.blobService.previewBlobs[uuid] = this.blobUrl;
        }
        // (error) => {
        //   console.log(error);
        // }
      );
    } else if (this.preview === 'mastermodel') {
      this.apiService.getMasterModelPreview(uuid).subscribe(
        (val: Blob) => {
          this.blobUrl = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val));
          // this.blobService.previewBlobs[uuid] = this.blobUrl;
        }
        // (error) => {
        //   console.log(error);
        // }
      );
    } else if (this.preview === 'mappingversion') {
      this.apiService.getVersionPreview(uuid).subscribe(
        (val: Blob) => {
          this.blobUrl = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val));
          // this.blobService.previewBlobs[uuid] = this.blobUrl;
        }
        // (error) => {
        //   console.log(error);
        // }
      );
    } else if (this.preview === 'molded') {
      this.blobUrl = this.png;
    } else {
      //this.blobUrl = this.blobService.previewBlobs[uuid];
    }
    // if (!this.blobService.previewBlobs[uuid] && this.preview === 'molded') {
    //   this.apiService.getmoldedVersionPreview(uuid).subscribe(
    //     (val) => {
    //       this.blobUrl = this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(val));
    //       this.blobService.previewBlobs[uuid] = this.blobUrl;
    //     }
    //     // (error) => {
    //     //   console.log(error);
    //     // }
    //   );
    // }
  }
}
